"use client";

type ApiFetchOptions = {
  method?: string;
  body?: BodyInit | null;
  headers?: HeadersInit;
};

export class ApiClientError extends Error {
  status: number;
  payload: any;

  constructor(message: string, status: number, payload: any) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

export async function apiFetch<T>(input: string, options: ApiFetchOptions = {}): Promise<T> {
  const response = await fetch(input, {
    method: options.method ?? (options.body ? "POST" : "GET"),
    body: options.body ?? null,
    headers: options.headers,
    credentials: "include",
  });

  if (!response.ok) {
    let payload: any = null;
    try {
      payload = await response.json();
    } catch {
      payload = await response.text().catch(() => null);
    }
    const message =
      (payload && typeof payload === "object" && typeof payload.error === "string" && payload.error) ||
      response.statusText ||
      "Request failed";
    throw new ApiClientError(message, response.status, payload);
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
}
